import { queryOptions } from '@tanstack/react-query'
import { apiClient, handleResponse } from '@/utils/axios-client.ts'
import {
  type Companies,
  CompaniesSchema,
  type Company,
  SitesResponseSchema,
  type Site
} from '@/features/companies/api/companies.data.ts' // Re-export types for convenience

// Re-export types for convenience
export type { Company, Companies }

const ENDPOINT = '/api/v1/companies'

export const companiesQueryOptions = (
  globalToken: string | Promise<string>
) =>
  queryOptions({
    queryKey: ['_global', 'companies'],
    queryFn: async ({ signal }) => fetchCompanies(await globalToken, signal),
    refetchOnWindowFocus: false, // Don't refetch on window focus
    staleTime: 2 * 60 * 1000
  })

export const sitesQueryOptions = () =>
  queryOptions({
    queryKey: ['sites'],
    queryFn: ({ signal }) => fetchSites(signal),
    staleTime: 2 * 60 * 1000
  })

export const fetchCompanies = async (
  globalToken: string,
  signal?: AbortSignal
): Promise<Companies> => {
  return await handleResponse(
    () =>
      apiClient.get(ENDPOINT, {
        headers: {
          Authorization: `Bearer ${globalToken}`
        },
        signal
      }),
    CompaniesSchema
  )
}

export const fetchSites = async (signal?: AbortSignal): Promise<Site[]> => {
  return await handleResponse(
    () => apiClient.get('/api/v1/sites', { signal }),
    SitesResponseSchema
  )
}
